import React, { ReactNode } from "react";
import { AuthProvider } from "@src/auth/auth-provider";
import styles from "./app-container.module.scss";

interface AppContainerPropTypes {
  children: ReactNode;
}

const cssClassName = "cloud-connect";

export const AppContainer = ({ children }: AppContainerPropTypes) => {
  return (
    <AuthProvider>
      <div className={styles[cssClassName]}>{children}</div>
    </AuthProvider>
  );
};
